module.exports = __webpack_public_path__ + "public-ui/img/logo.08490684.svg";